<!--
 * @Author: Lemon C
 * @Date: 2024-06-13 10:48:20
 * @LastEditTime: 2025-03-12 11:44:35
-->
<template>
    <div class="sup-user-dialog" v-if="dialog_visible" @click.self="bg_click">
        <transition name="user_box_fade">
            <div class="user-box" :style="`left: ${state_store.nav_user_box_pos.left}px`" v-if="user_box_visible">
                <div class="item-box" @click="show_message_center">
                    <img src="@/assets/imgs/login/icon_xiaoxi.png" />
                    <span>{{ `消息(${user_store.userMsgNum})` }}</span>
                </div>
                <!-- <div class="item-line"></div> -->
                <div class="item-box" @click="change_user">
                    <img src="@/assets/imgs/login/icon_qiehuanzhanghao.png" />
                    <span>切换账号</span>
                </div>
                <!-- <div class="item-line"></div> -->
                <div class="item-box" @click="logout">
                    <img src="@/assets/imgs/login/icon_tuichudenglu.png" />
                    <span>退出登录</span>
                </div>
            </div>
        </transition>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, getCurrentInstance, nextTick } from 'vue';
import { useRouterStore } from '@/stores/router';
import { useUserStore } from '@/stores/user';
import { useStateStore } from '@/stores/state';

const router_store = useRouterStore();
const user_store = useUserStore();
const state_store = useStateStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
    dialog_changeUser_callback: Function,
});

const dialog_visible = ref(false);
const user_box_visible = ref(false);

// MARK Expose 隐藏
const show_dialog = () => {
    dialog_visible.value = true;
    nextTick(() => {
        user_box_visible.value = true;
    });
};

// MARK Expose 隐藏
const hide_dialog = () => {
    user_box_visible.value = false;
    setTimeout(() => {
        dialog_visible.value = false;
    }, 500);
};

// MARK Click 底部点击
const bg_click = () => {
    hide_dialog();
};

// MARK Expose 导出方法
defineExpose({
    show_dialog,
    hide_dialog,
});

// MARK Click 切换账号
const change_user = () => {
    hide_dialog();
    props.dialog_changeUser_callback();
};

// MARK Click 退出登录
const logout = () => {
    user_store.service_logout((error) => {
        if (error) {
            proxy.$message.error(error);
        } else {
            proxy.$message.success('退出登录成功');
        }
        hide_dialog();
    });
};

// MARK Click 消息中心
const show_message_center = () => {
    hide_dialog();
    router_store.navigateToMsg();
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-user-dialog {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--color-main-bg-transparent);
    z-index: var(--user-z-index);

    .user-box {
        position: absolute;
        // top: calc(5px + var(--nav-height));
        top: 74px;
        width: 148px;
        max-height: 560px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 8px;
        box-sizing: border-box;
        background: var(--color-main-black-bg);
        backdrop-filter: var(--color-main-backdrop-filte);
        // background: var(--color-main-login-backdrop-filter-background);
        // background-color: var(--color-main-login-bg-dark-transparent);
        border-radius: 6px;
        transition: opacity 0.5s ease-in-out;
        z-index: var(--user-z-index);
        cursor: pointer;

        .item-box {
            position: relative;
            width: 100%;
            height: 30px;
            margin-bottom: 7px;
            display: flex;
            align-items: center;
            padding: 3px 16px;
            box-sizing: border-box;
            border-radius: 6px;

            img {
                position: relative;
                width: 18px;
                height: 18px;
            }

            span {
                position: relative;
                margin-left: 10px;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                color: var(--color-main-text-dark-bg-primary);
            }

            &:last-child {
                margin-bottom: unset;
            }

            &:hover {
                background-color: rgba(255, 255, 255, 0.1);
                // background-color: red;
            }
        }

        .item-line {
            position: relative;
            width: 100%;
            height: 1px;
            border: 1px solid rgba(0, 0, 0, 0.2);
        }
    }

    .user_box_fade-enter-active,
    .user_box_fade-leave-active {
        transition: opacity 0.5s;
    }

    .user_box_fade-enter-from,
    .user_box_fade-leave-to {
        opacity: 0;
    }
}
</style>
